import { Link } from 'react-router-dom';

type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        <li>
          <Link to="/" className="cursor-pointer hover:text-primary-700">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line" />
            {item.to ? (
              <Link to={item.to} className="cursor-pointer hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}